var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgtemp"},[_c('div',{staticClass:"imgtemp-title-box SourceHanSansCN-Regular"},[_c('div',{staticClass:"imgtemp-title"},[_vm._v(_vm._s(_vm.title))]),_c('el-button',{staticClass:"imgtemp-title-box-btn floating-btn",attrs:{"icon":"el-icon-bottom","circle":""}})],1),_c('img',{attrs:{"src":_vm.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }